import React from "react"

import Layout from "../components/layout"
import SEO from "../components/seo"

const ProfilePage = () => (
  <Layout>
    <SEO description="プロフィール" title="実務のGo" />
    <section class="section">
      <div class="container has-text-centered">
        <div class="content">
          <h1>プロフィール</h1>
        </div>
      </div>
      <hr/>
      <div class="container">
        <div class="content">
          <h2 class="title">作成者紹介</h2>
          <p>2004年からシステムエンジニアとしてシステム開発の仕事を開始。 </p>
          <p>Slerでのシステム開発、WEB会社でのアプリ開発、サーバー構築、ネイティブスマホアプリ開発を経て、2016年8月に独立。 その後、複数のスタートアップの開発に参画。</p>
          <p>2018年末からは機械学習のプロジェクトにもJOIN中。</p>
          <p>Twitter：<a href="https://twitter.com/masa_kakaroto" target="blank">@masa_kakaroto</a></p>
          <p>Blog：<a href="https://www.marsa-blog.com/" target="blank">Marsaブログ</a></p>
          <h2 class="title">スキル</h2>
          <p>Java, Struts, Struts2, Seasar2, Mysql, Postgres, Oracle, mongo, LDAP, PHP, Ruby, Ruby on Rails, Scala, Android, Objective-C, C++, Rxjava, Kotlin, Postfix, AWS, docker, ECS, GCP, BigQuery, python, pandas, dask, sklearn, tensorflow, keras, react, typescript, Rust, WebAssembly, Gatsby他多数</p>
          <h2 class="title">このサイトで利用している技術</h2>
          <p>Gatsby, typescript, Bulma, netlify</p>
        </div>
      </div>
    </section>
  </Layout>
)

export default ProfilePage
